import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import React from 'react'

type CSVTableProps = Readonly<{ data: { [key: string]: any }[]; schema: { [key: string]: string } }>

const MAX_CELL_CHARS = 1000
export const CSVTable = React.memo(({ schema, data }: CSVTableProps) => (
  <div className='w-full'>
    <Table className='rounded-lg text-sm'>
      <TableHeader className='border-0 bg-transparent'>
        <TableRow>
          {Object.keys(schema).map((header) => (
            <TableHead
              className='bg-neutral-white px-4 first:rounded-tl-lg last:rounded-tr-lg'
              key={header}
            >
              {header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((row, rowIndex) => (
          <TableRow
            key={JSON.stringify(row)}
            className='odd:bg-neutral-75/90 even:bg-neutral-75/20'
          >
            {Object.values(row).map((_value, cellIndex) => {
              const str = toString(_value)
              const value =
                str.length <= MAX_CELL_CHARS ? str : `${str.substring(0, MAX_CELL_CHARS)}...`
              return (
                <TableCell
                  key={`${value}-${rowIndex}-${cellIndex}`}
                  className='border-b-0 px-4 py-2'
                >
                  {value}
                </TableCell>
              )
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
))

function toString(value: any) {
  if (!value) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object') return JSON.stringify(value)
  return `${value}`
}
